<template>
  <div class="CompanyInfo">
    <div class="main">
      <div class="qrcode">
        <img  :src="img_qrcode" />
        <p class="remark">扫码关注官方微信</p>
      </div>
      <div class="Info">
        <p>免费热线：（0512）65929315</p>
        <p>QQ：1048789942</p>
        <p>邮箱：service@raipeng.com</p>
        <p>地址：苏州市工业园区独墅湖崇文路创意产业园7栋8楼</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyInfo',
  data () {
    return {
      img_qrcode: require("@/assets/imgs/img-qrcode.png")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
  .CompanyInfo{

    .main {
      width: 1200px;
      margin: 0 auto;
      padding: 60px 0;

      .qrcode {
        width: 230px;
        display: inline-block;
        margin-left: 105px;

        img{
          width: 230px;
          height: 230px;
          display: inline-block;
          margin: 0 auto;
        }
        .remark {
          font-size:18px;
          font-family:SourceHanSansCN-Normal;
          font-weight:400;
          color:rgba(0,0,0,1);
          line-height:48px;
          text-align: center;
        }
      }
      .Info {
        display: inline-block;
        vertical-align: top;
        margin-left: 76px;

        p {
          font-size:24px;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:rgba(0,0,0,1);
          line-height:58px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact_Us/CompanyInfo.vue